import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FC, useEffect } from "react";
import { RouteComponentProps } from "react-router";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { ViewContainer } from "components/grid";
import Flex from "components/layout/Flex";
import { SectionOnboardingBanner } from "components/section-onboarding-banner/SectionOnboardingBanner";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { isInIframe } from "helpers/app";
import { withVar } from "themes/helpers";

import { IframeHeader } from "../components/IframeHeader";
import { IframeOnboardingBanner } from "../components/IframeOnboardingBanner";
import { MainViewContent } from "../components/MainViewContent";

const Workflows: FC<RouteComponentProps> = ({ history }) => {
  const embeddedInIframe = isInIframe();

  useEffect(() => {
    trackEngagement("Automations: Automated workflows section opened", EventPlace.Automations);
  }, []);

  if (embeddedInIframe) {
    return (
      <IframeViewContainer>
        <IframeHeader />
        <Flex padding={withVar(SpacingToken.Spacing8)} justifyContent="center">
          <Flex width="100%" column gap={withVar(SpacingToken.Spacing8)}>
            <IframeOnboardingBanner />
            <MainViewContent history={history} />
          </Flex>
        </Flex>
      </IframeViewContainer>
    );
  }

  return (
    <ViewContainer title="Rules" contentCss={css({ overflowY: "scroll" })}>
      <Flex padding={withVar(SpacingToken.Spacing8)} justifyContent="center">
        <Flex maxWidth="960px" width="100%" column gap={withVar(SpacingToken.Spacing8)}>
          <SectionOnboardingBanner section="workflows" autoDisplayForAllUsers />
          <MainViewContent history={history} />
        </Flex>
      </Flex>
    </ViewContainer>
  );
};

export default Workflows;

const IframeViewContainer = styled.div`
  position: relative;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  color: ${withVar(DesignToken.ContentBasicPrimary)};
`;
